import { combineReducers } from "redux";

import { bedsDetails } from "./reducer.beds"
const bedReducers = combineReducers({

  bedsDetails

})
export default bedReducers;
